import { Column } from 'devextreme-react/data-grid';
import React, { useCallback, useState, useEffect } from 'react';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import columnDataGrid from './columnDataGrid';
import HeaderButtonMVP from '../../HeaderButtonMVP';
import DataGridMVP from '../../DataGridMVP';
import StornoCommentPopup from '../../StornoCommentPopup/StornoCommentPopup';
import ConfirmSkPopup from '../../ConfirmSkPopup/ConfirmSkPopup';
import useWasteColumns from '../../../hooks/useWasteColumns';

const FinishedProductConfirmation = ({
  finishedProductReducer: {
    listFinishedProductNormalizedToTable,
    okRequest,
    loadingGet
  },
  tabsReducer: { tabSelect },
  userReducer: { permissions },
  confirmFinishedProduct,
  getFinishedProduct,
  modalErrorOpen,
  plantId,
  selectedIndex,
  setCancelSendToSap,
  stornoFinishedProduct,
  useFactWeight
}) => {
  const [
    selectedFinishedProductList,
    setSelectedFinishedProductList
  ] = useState([]);
  const [headerVisible, setHeaderVisible] = useState({ display: 'none' });
  const [stornoActive, setStornoActive] = useState(true);
  const [confirmationActive, setConfirmationActive] = useState(true);
  const [selectedFinishedProductData, setSelectedFinishedProductData] = useState([]);
  const [filterFinishedProduct, setFilterFinishedProduct] = useState({
    dateFrom: '',
    dateTo: '',
    filter: ''
  });

  const [confirmPopupVisible, setConfirmPopupVisible] = useState(false);
  const [stornoPopupVisible, setStornoPopupVisible] = useState(false);
  const [comment, setComment] = useState('');
  const [dataGridInstance, setThisDataGridInstance] = useState(null);
  const [dataWithWaste, quantityColumns] = useWasteColumns(listFinishedProductNormalizedToTable);

  /** Видимость кнопки - Отмена отправки */
  const [visibleCancelBtn, setVisibleCancelBtn] = useState({
    btnAdmin: false
  });

  useEffect(() => {
    if (permissions.length) {
      setVisibleCancelBtn({
        btnAdmin: (permissions.indexOf('btnUserAdmin') !== -1)
        || (permissions.indexOf('btnSesAdmin') !== -1)
      });
    }
  }, [permissions]);

  useEffect(() => {
    const selected = dataGridInstance && dataGridInstance.props.selectedRowKeys
      ? dataGridInstance.props.dataSource.filter((el) =>
        dataGridInstance.props.selectedRowKeys.includes(
          el.finishedProductId
        ))
      : [];
    const correctProduct = selected.every(
      (el) => el.readyPsStatusName === 'В наличии'
    );
    const sentProduct = selected.every(
      (el) => el.readyPsStatusName === 'Отправлен'
    );
    const createdProduct = selected.every(
      (el) => el.readyPsStatusName === 'Создан'
    );
    if (sentProduct
      && selectedFinishedProductData.length
      && ((permissions.indexOf('btnUserAdmin') !== -1)
        || (permissions.indexOf('btnSesAdmin') !== -1))) {
      setVisibleCancelBtn((prevState) => ({ ...prevState, btnAdmin: true }));
    } else {
      setVisibleCancelBtn((prevState) => ({ ...prevState, btnAdmin: false }));
    }
    if (correctProduct && selectedFinishedProductData.length) {
      setStornoActive(false);
    } else {
      setStornoActive(true);
    }
    if (createdProduct && selectedFinishedProductData.length) {
      setConfirmationActive(false);
    } else {
      setConfirmationActive(true);
    }
  }, [
    selectedFinishedProductData,
    selectedFinishedProductList,
    listFinishedProductNormalizedToTable,
    dataGridInstance,
    permissions
  ]);

  useEffect(() => {
    if (
      selectedFinishedProductData.length
      && selectedFinishedProductList.length
    ) {
      setHeaderVisible({ display: 'flex', width: 'fit-content' });
    } else {
      setHeaderVisible({ display: 'none' });
    }
  }, [selectedFinishedProductData.length, selectedFinishedProductList.length]);

  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('pieceStatusChanged'),
          height: 64,
          width: 354,
          position: { at: 'top center', my: 'top center', offset: '0 48' }
        },
        'success',
        2000
      );
      dataGridInstance.instance.clearSelection();
    }
  }, [okRequest, dataGridInstance]);

  const onSelectionChanged = useCallback((selected) => {
    setSelectedFinishedProductData(selected.selectedRowsData);
  }, []);

  const onCellClick = useCallback(
    async (e) => {
      const isSelection = e.column.command === 'select';
      if (!isSelection) {
        return;
      }
      const filteredItems = await e.component
        .getDataSource()
        .store()
        .load({ filter: e.component.getCombinedFilter() });
      const currentClicked = {
        key: e.key,
        data: e.data
      };
      let newSelected = [];
      if (
        !e.key
        && !e.data
        && filteredItems.length
          !== selectedFinishedProductList.length
      ) {
        newSelected = filteredItems.map((el) => el.finishedProductId);
      } else if (!e.key && !e.data) {
        newSelected = [];
      } else if (selectedFinishedProductList.includes(currentClicked.key)) {
        newSelected = selectedFinishedProductList.filter(
          (el) => el !== currentClicked.key
        );
      } else {
        const {
          readyPieceId,
          readyQcId,
          readyAccountingDate,
          readyMessageId
        } = currentClicked.data;
        let sameElementsToCheck = [];
        if (readyMessageId) {
          sameElementsToCheck = listFinishedProductNormalizedToTable.filter(
            (el) => el.readyMessageId === readyMessageId
          );
        } else {
          sameElementsToCheck = listFinishedProductNormalizedToTable.filter(
            (el) =>
              el.readyPieceId === readyPieceId
              && el.readyQcId === readyQcId
              && el.readyAccountingDate === readyAccountingDate
          );
        }
        sameElementsToCheck = sameElementsToCheck.map(
          (el) => el.finishedProductId
        );
        newSelected = [
          ...selectedFinishedProductList,
          currentClicked.key,
          ...sameElementsToCheck
        ];
      }
      setSelectedFinishedProductList(() => newSelected);
    },
    [listFinishedProductNormalizedToTable, selectedFinishedProductList]
  );

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    getFinishedProduct({
      ...filterFinishedProduct,
      plantId
    });
  }, [filterFinishedProduct, getFinishedProduct, plantId]);

  const onCancelPopup = useCallback(() => {
    if (dataGridInstance && dataGridInstance.instance) {
      setConfirmPopupVisible(false);
      setStornoPopupVisible(false);
      setVisibleCancelBtn((prevState) => ({ ...prevState, btnAdmin: false }));
      dataGridInstance.instance.deselectAll();
      setSelectedFinishedProductList([]);
    }
  }, [dataGridInstance]);

  const onConfirmationClick = () => {
    setConfirmPopupVisible(true);
  };

  const onConfirmFinishedProduct = () => {
    const finishedProductIds = selectedFinishedProductData.map(
      (el) => el.readyPieceNumId
    );
    confirmFinishedProduct(finishedProductIds);
    onCancelPopup();
  };

  const onStornoClick = () => {
    setStornoPopupVisible(true);
  };

  const onStornoFinishedProduct = () => {
    const readyProductsIds = selectedFinishedProductData.map(
      (el) => el.readyPieceNumId
    );
    stornoFinishedProduct({ readyProductsIds, comment });
    onCancelPopup();
  };

  useEffect(() => {
    if (selectedIndex === 3 && tabSelect === 8) {
      const {
        dateFrom,
        dateTo,
        filter
      } = filterFinishedProduct;
      getFinishedProduct({
        plantId,
        dateFrom: dateFrom || '',
        dateTo: dateTo || '',
        filter: filter || ''
      });
    }
  }, [
    getFinishedProduct,
    plantId,
    tabSelect,
    okRequest,
    filterFinishedProduct,
    selectedIndex
  ]);

  const onClickButtonCancelSend = useCallback(() => {
    let blockCancelBtn = false;
    selectedFinishedProductData.forEach((item) => {
      if (item.readyPsStatusName === 'Создан') {
        blockCancelBtn = true;
      }
    });
    if (blockCancelBtn) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textSelectSentOnly}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else {
      const readyProductsIds = selectedFinishedProductData.map(
        (el) => el.readyPieceNumId
      );
      setCancelSendToSap({ readyProductsIds });
      onCancelPopup();
    }
  }, [modalErrorOpen, onCancelPopup, selectedFinishedProductData, setCancelSendToSap]);

  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterFinishedProduct(prev => ({ ...prev, filter: value }));
    }
  }, []);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headerVisible}>
        <Button
          text={formatMessage('textButton').storno}
          type={'default'}
          stylingMode={'contained'}
          disabled={stornoActive}
          onClick={onStornoClick}
        />
        <Button
          text={formatMessage('textButton').confirm}
          type={'default'}
          stylingMode={'contained'}
          disabled={confirmationActive}
          onClick={onConfirmationClick}
        />
        {visibleCancelBtn.btnAdmin ? (
          <Button text={formatMessage('textButton').cancelSend}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickButtonCancelSend}
          />
        ) : (
          ''
        )}
      </HeaderButtonMVP>
      <DataGridMVP
        dataSource={dataWithWaste}
        setDataGridInstance={setThisDataGridInstance}
        selectedRowKeys={selectedFinishedProductList}
        onCellClick={onCellClick}
        onSelectionChanged={onSelectionChanged}
        filterDataGrid={filterFinishedProduct}
        setFilterDataGrid={setFilterFinishedProduct}
        className="shipment"
        keyExpr="finishedProductId"
        setStateStoringName={'finishedProductionDataGridData'}
        dataGridOnOptionChanged={dataGridOnOptionChanged}
        tText={formatMessage('textPeriod')}
        visibleButtonDateRangePicker
        visibleInfoIcon={false}
        isDataLoading={loadingGet}
        visibleGroupPanel={false}
        visibleActyalButton={false}
        visibleSummary
        onFilterChanged={() => {
          setSelectedFinishedProductList([]);
        }}
        onClickUpdate={onClickUpdate}
        visibleButtonQRCode={false}
        scrollingMode="standard"
        visibleButtonAddResponsiblePerson={false}
        visibleButtonCheckAll={false}
        visibleButtonUpdate
        altWeightNettoField="readyWeightForSumNetto"
        altWeightBruttoField="readyWeightForSumOff"
        isUnique
        units={selectedFinishedProductData && selectedFinishedProductData.length
          ? selectedFinishedProductData[0].unitShort
          : dataWithWaste && dataWithWaste.length
            ? dataWithWaste[0].unitShort
            : 'tonne'}
      >
        {columnDataGrid.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch
            allowFiltering
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
        {quantityColumns}
      </DataGridMVP>
      <ConfirmSkPopup
        visible={confirmPopupVisible}
        onHiding={onCancelPopup}
        qcIds={
          selectedFinishedProductData.length
          && selectedFinishedProductData.map((el) => el.readyQcId)
        }
        dates={
          selectedFinishedProductData.length
          && selectedFinishedProductData.map((el) => el.readyAccountingDate)
        }
        onConfirm={onConfirmFinishedProduct}
      />
      <StornoCommentPopup
        visible={stornoPopupVisible}
        onHiding={onCancelPopup}
        comment={comment}
        setComment={setComment}
        onConfirm={onStornoFinishedProduct}
        modalErrorOpen={modalErrorOpen}
      />
    </>
  );
};

export default React.memo(FinishedProductConfirmation);
